import { render, staticRenderFns } from "./TempoSelector.vue?vue&type=template&id=153d7742&"
import script from "./TempoSelector.vue?vue&type=script&lang=js&"
export * from "./TempoSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports